import { ExternalInvoiceBalanceModifierReference } from '../../InvoiceViewActions/enums/ExternalInvoiceBalanceModifierReference'

export const externalInvoiceBalanceModifierReferenceToTKey: Record<ExternalInvoiceBalanceModifierReference, string> = {
  [ExternalInvoiceBalanceModifierReference.BankPayment]: 'invoices.view.payment_pane.modifier.bank_payment',

  [ExternalInvoiceBalanceModifierReference.Invoice]: 'invoices.view.payment_pane.modifier.invoice',
  [ExternalInvoiceBalanceModifierReference.ExternalInvoice]: 'invoices.view.payment_pane.modifier.invoice',
  [ExternalInvoiceBalanceModifierReference.InvoiceLateFee]: 'invoices.view.payment_pane.modifier.invoice_late_fee',
  [ExternalInvoiceBalanceModifierReference.CreditNote]: 'invoices.view.payment_pane.modifier.credit_note',
  [ExternalInvoiceBalanceModifierReference.ContactBalancePayment]:
    'invoices.view.payment_pane.modifier.contact_balance_payment',
  [ExternalInvoiceBalanceModifierReference.DaybookTransaction]:
    'invoices.view.payment_pane.modifier.daybook_transaction',
}
